/* Desc 维护说明   ---- htmlValue()
1. @param 参数说明将会高亮显示
2. {}括号 将会高亮显示并做空格处理
3. -- 将会高亮显示 用于二级参数说明或其次内容说明
4. 。句号将会做换行处理
5. ## 井号将会高亮显示 用于特别强调内容
*/

export const Desc = {
  // ----------------------------   描述相关   ------------------------------------------------------------
  // rich_element功能说明
  tableData: [
    {
      ComponentsName: 'ElTable表格',
      npm: 'https://www.npmjs.com/package/rich_element',
      extend: '1.表头标题超出隐藏并hove提示。2.表格拖不出横向滚动条(已废弃)',
      explain: "-",
      versions: '@1.1.6, @1.1.10 @1.1.14'
    },
    {
      ComponentsName: 'ElInputNumber计数器',
      npm: 'https://www.npmjs.com/package/rich_element',
      extend: '1.修复计数器无法限制最大输入长度问题，默认长度为15',
      explain: "-",
      versions: '@1.1.14'
    },
    {
      ComponentsName: 'ElAutocomplete拼音码',
      npm: 'https://www.npmjs.com/package/rich_element',
      extend: '1.无数据时的友好优化。2.文字的高亮效果。3.样式被影响的修复',
      explain: "-",
      versions: '@1.1.10 , @1.1.14'
    }
  ],
  // rich-element更新日志
  RichElementDesc: `
      ## 更新日志。
      -- 1.0.0 ~ 1.0.2 初始版本 不使用（2022.8.27）。
      -- 1.0.3 ~ 1.0.7 已废弃！（2022.8.29）。
      -- 1.0.8 ~ 1.1.0 已废弃！（2022.9.02）。
      -- 1.1.6  { 支持表头超出自动省略并hove提示} ， {添加列表拖动限制（现已废弃！）}（2022.9.02）。
      -- 1.1.9  { 拼音码无数据时的友好交互 }，{ 添加无数据时的样式 }（2022.9.06）。
      -- 1.1.10 { 修复拼音码无数据不关闭弹窗 }， { 修复拼音码异常报错bug }（2022.9.15）。
      -- 1.1.11 { 计数器组件修复原生maxlength树形绑定不上问题 } ， { 计数器添加默认长度限制防止出现科学计数法 }（2022.9.20）。
      -- 1.1.12 ~ 1.1.13  ##异常原因崩溃版本 ##不能使用 （2022.9.22）。
      -- 1.1.14 { 崩溃修复 ，向下兼容所有版本 } <s>##建议使用版本 </s>（2022.9.22）。
      -- 1.1.15 {  极限测试下报错修复 } ##建议使用版本 （2022.10.2）。
      --。
      ## 引用方式。
      -- 1. npm i rich_element@xx.xx || yarn add rich_element@xx.xx （下载依赖包）。
      -- 2. import { Table, Autocomplete } from 'rich_element';  对应组件按需导入（main.js按需导入） 。
      -- 3. import 'rich_element/lib/theme-chalk/index.css';  导入重构样式表 （main.js导入）。
      -- 4. Vue.component('ElTable', Table); 全局注册覆盖element组件 或 另起别名局部使用重构后的组件。
      --。
      ## 属性配置。
      -- ElTable表格: { extension(已废弃)} , { 其余功能不用配置属性自动支持}。
      -- ElInputNumber:  { maxlength(最大长度默认15) }, {其余功能不用配置即支持}。
      -- ElAutocomplete: { highlightShow(是否高亮关键字默认false) },{ 其余功能不用配置即支持}。
      `,
  // AutocompleteReset 拼音码 描述
  AutocompleteResetDesc: `
        @param input{ Function }。 数据变更时通知，参数会默认同步到v-model绑定的值
          如果你想获取更多的关联值 请在使用处 @input="inputs(arguments)，你选中的Object对象会注入的数组的 [1]项里 ，[0]为v-model。
        @param alteration{ Function }。 数据变更的回调区别于 input alteration 只会在点选或者粘贴处理时才会触发 @alteration=xxxx($event)。
        @param formData { Object }  拼音码需要两个字段维护时 除v-model绑定外 另一个值需要同步给的对象，需要搭配config.soleValue使用。
        @param config 必要的 { Object }。
                -- config.url { String } 要请求的地址 默认为承运商。
                -- config.queryStr { String }  请求接口的查询参数字段 默认searchCode。
                -- config.label { String }  要显示的拼音码字段 默认carrierName。
                -- config.value { String }  要传给后台的拼音码字段 默认carrierCode。
                -- config.PasteType { Boolean }  是否处理粘贴数据 默认true。
                -- config.placeholder { String } placeholder显示名称。
                -- config.soleValue { String } 需要存储的唯一字段名（id,code）。
                -- config.triggerType { Boolean } 是否需要在输入框获取焦点时获取数据 默认true。
                -- config.disabled { Boolean } 原生属性。
                -- config.maxlength { String || Number } 原生属性 默认20。
                -- config.selectType 暂未启用。
                -- config.customQuery { Object } 自定义其他查询参数。
                -- config.highlightShow { Boolean }  是否高亮关键字。
                -- config.onState { Boolean }  是否辅助录入。
      ## 特别说明。
      ## 如果你尝试不用处理函数同时在使用时存储两个字段的值 传入formData (数据源对象) 并且在config中传入你的字段key（config.soleValue）。
      ##当自动处理两个字段不够用时 @alteration 将会把你的选择项 {Object} 通过$event 注入到你的回调里，  *用于带出其他值，只关注本身的两个值传入formData即可。
      ## 高亮关键字需要下载rich_element，最低的支持版本为 @1.1.14。
      ------------------------------------------------。 

      ---------------- { 简化调用方式说明 } ---------------- 。
      ## 原版支持参数全部兼容调用方式不变 。
      @param typeUse {String}  2022.11.01版本添加使用，可以不传config 转移到{ autocomplete-config.js } 维护常用配置。
             typeUse  会去兼容 config  如果当需要替换 url soleValue queryStr... 等参数 config配置时 传入config配置进行覆盖即可。
      ## 取配置优先级  config传参 > autocomplete-config.js配置 > 默认值。
      ## autocomplete_config.js常用配置里， 存储字段（soleValue）已给默认值 如：产品  存储字段（soleValue） = custNo， 建议常用拼音码字段统一，如特殊情况传入config配置进行覆盖。
      ## 新增常用配置 移步 autocomplete-config.js 按照格式添加。
 `,
  AutocompleteResetDesc2: `
  ---------------- { 简化调用方式说明 } ---------------- 。
  ## 原版支持参数全部兼容调用方式不变 。
  @param typeUse {String}  2022.11.01版本添加使用，可以不传config 转移到{ autocomplete-config.js } 维护常用配置。
         typeUse  会去兼容 config  如果当需要替换 url soleValue queryStr... 等参数 config配置时 传入config配置进行覆盖即可。
  ## 取配置优先级  config传参 > autocomplete-config.js配置 > 默认值。
  ## autocomplete_config.js常用配置里， 存储字段（soleValue）已给默认值 如：产品  存储字段（soleValue） = custNo， 建议常用拼音码字段统一，如特殊情况传入config配置进行覆盖。
  ## 新增常用配置 移步 autocomplete-config.js 按照格式添加。
  `,
  // SelectTree 树形查询 描述
  SelectTreeDesc: `
      @param  props { Object }
        --value: 'id',       value字段名。
        --label: 'deptName',  显示名称。
        --children: 'children', 子级字段名。
      @param  options { Array } 树形结构的对象数组. 这是必要的。
      @param  clearable { Boolean  } 是否需要清空功能。
      @param  placeholder { String  } 数检索关键字。
      @param  accordion { Boolean  } 自动收起 默认false。
      @param  disabled { Boolean  } 是否禁用。
`,
  // dialog-reset 对话框组件 描述
  DialogResetDesc: `
     @param visible { Boolean } 同element语法糖修改v-model绑定的值 （控制显隐）。
     @param title 传入标题。
     @param width 对话框宽度 默认55%。
     @param top  对话框距离顶部距离。
     @param DialogClass 传入的自定义class样式 请用 ::v-deep。
     @param dialog_footer { 具名插槽 }  作用到el-dialog footer 插槽里。
     @param modalShow { Boolean }  是否需要遮罩层。
     @param zoomShow { Boolean }  是否缩放功能。
     @param ask_Dialogdrag { Boolean }  是否拖拽功能。
     @param height { String }  对话框内容区域高度默认50vh。
     @param slotShow { Boolean }  是否启用element插槽。
     ## 注意。
     ## 取插槽优先级  slotShow > dialog_footer。
     ## 当嵌入组件使用时 盒子calss名为dialog_footer会被组件在实体dom中删除并嵌入到对话框插槽中，对业务结构的虚拟dom没有影响, dialog_footer不要嵌套很深否则可能出现重复节点问题。
     ## <s> saber-admin框架集成对话框提供的现有方案存在问题，为了保证功能的一致性建议{特殊需要拖动的功能才添加拖动} ，TODO：该框架问题在未来会尝试解决</s> （##该问题已在--10.11基础版本中得到解决）。
     ## <s>目前拖动和缩放功能不要同时使用，将会引起混乱，TODO：这部分在未来可能会被优化</s>（##该问题已在--9.29基础版本中得到解决）。
      `,
  // CustomInput 输入框 描述
  CustomInputDesc: `
  @param  value { Number || String } 绑定值。
  @param  precision { Number } 设置精准值（保留多少位小数）。
  @param  maxlength { Number  } 最大输入长度。
  @param  placeholder { String  } 输入框占位文本。
  @param  readonly { boolean  } 是否只读。
  @param  disabled { boolean  } 禁用。
  `,

  DateCodeDesc: `
  --  此配置仅支持查询相关， 表单如有默认值需求使用 通用函数{getAllWeekBeforeNowFn}实现即可。
  --  仅展示结构 非此演示相关配置省略, 具体配置参考此页面 Avue 常用 option 参数说明中 {searchDateProp} 参数。
  --  生成代码实现对应效果 复制对应配置即可， 自定义的可参照具体实例源码。
  --  字段为 searchDate的时间集配置 默认处理{searchDateProp}配置 默认一周。
  ##  通用处理的 searchDateProp 只能处理一个或一组
  `,

  // -----------------------------  end   -----------------------------------------------------------------


  //-----------------------------  代码片段  ---------------------------------------------------------------
  //  拼音码
  RichElementCode1_1: `<template>
  <el-form ref="form"
          :model="form"
          label-width="150px">
       <el-form-item label="普通录入:">
        <!-- 缺少url接口 可传入[{varNo:'cp',varName:'物资名称'}] 模拟接口返回的数据查看效果（仅demo）-->
         <autocomplete-reset v-model="form.varName"
                             :formData="form"
                             :config="{
                                     url:'/api/blade-vardict/vardict/searchCode',  
                                     value:'varNo',
                                     label:'varName',
                                     soleValue :'varNo',
                                   }"
                             style="width:100%">
         </autocomplete-reset>
       </el-form-item>
  </el-form>
</template>
<script>
export default {
 data() {
   return {
     form: {},
   }
 },
}
</script>
 `,
  RichElementCode1_2: ` <template>
 <el-form ref="form"
         :model="form"
         label-width="150px">
         <el-form-item label="自定义录入:">
         <!-- 缺少url接口 可传入[{varNo:'cp',varName:'物资名称'}] 模拟接口返回的数据查看效果（仅demo）-->
         <autocomplete-reset v-model="form.varName2"
                             :formData="form"
                             :config="{
                                     url:'/api/blade-vardict/vardict/searchCode',
                                     value:'varNo',
                                     label:'varName',
                                     soleValue :'varNo2',
                                     onState:true
                                   }"
                             style="width:100%">
         </autocomplete-reset>
       </el-form-item>
       <el-form-item label="高亮关键字:">
       <autocomplete-reset v-model="form.varName3"
                           :formData="form"
                           :config="{
                                   url:'/api/blade-vardict/vardict/searchCode',
                                   value:'varNo',
                                   label:'varName',
                                   soleValue :'varNo3',
                                   highlightShow:true,
                                   placeholder:'需配合rich_element@1.1.14使用',
                                   onState:true
                                 }"
                           style="width:100%">
       </autocomplete-reset>
     </el-form-item>
 </el-form>
</template>
<script>
export default {
data() {
  return {
    form: {},
  }
},
}
</script>
`,
  RichElementCode1_3: ` <template>
<el-form ref="form"
        :model="form"
        label-width="150px">
        <el-form-item label="数据带出:">
        <!-- 缺少url接口 可传入[{varNo:'cp',varName:'物资名称'}] 模拟接口返回的数据查看效果（仅demo）-->
          <autocomplete-reset v-model="form.varName4"
                              :formData="form"
                              :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo4',
                                      onState:true ,
                                      PasteType:false
                                    }"
                              style="width:100%"
                              @alteration="varAlteration">
          </autocomplete-reset>
        </el-form-item>
        <el-form-item label="粘贴处理并带出:">
        <!-- 缺少url接口 可传入[{varNo:'cp',varName:'物资名称'}] 模拟接口返回的数据查看效果（仅demo）-->
          <autocomplete-reset @alteration="varAlteration2"
                              ref="autocomplete"
                              v-model="form.varName5"
                              :formData="form"
                              :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo5',
                                      onState:true
                                    }"
                              style="width:100%">
          </autocomplete-reset>
        </el-form-item>
</el-form>
</template>
<script>
export default {
data() {
 return {
   form: {},
 }
},
}
</script>
`,
  RichElementCode2_1: ` 
  <template>
  <!-- 缺少url接口 可传入 config={url: [{varNo:'cp',varName:'物资名称'}]}  模拟接口返回的数据查看效果（仅demo）-->
      <el-form ref="form"
      :model="form"
      label-width="150px">
          <!-- 参数与默认配置完全一致 （产品配置 ）-->
            <el-form-item label="配置默认varNo:">
              <autocomplete-reset v-model="form.varName6" typeUse="varNo" :formData="form" /> 
            </el-form-item>
            <!-- 参数与默认配置完全一致 （客户配置 ）-->
            <el-form-item label="配置默认custNo:">
              <autocomplete-reset v-model="form.varName7" typeUse="custNo" :formData="form" /> 
            </el-form-item>
      </el-form>
  </template>
  <script>
  export default {
      data() {
        return {
          form: {},
        }
      },
    }
  </script>
`,
  RichElementCode2_2: ` 
      <template>
      <!-- 缺少url接口 可传入 config={url: [{varNo:'cp',varName:'物资名称'}]}  模拟接口返回的数据查看效果（仅demo）-->
      <el-form ref="form"
        :model="form"
        label-width="150px">
              <!-- 参数与配置部分不同 -->
              <el-form-item label="仅soleValue参数不同:">
                <autocomplete-reset v-model="form.varName8" typeUse="varNo"  :formData="form" 
                                  :config="{soleValue :'varNo',}"                                            
                /> 
              </el-form-item>
              <!-- 多个参数与简化不同时 -->
              <el-form-item label="多个参数不同时:">
                <autocomplete-reset v-model="form.varName9" typeUse="varNo"  :formData="form" 
                                  :config="{soleValue :'varNo', PasteType:true,maxlength:'30'}"                                            
                /> 
              </el-form-item>
          </el-form>
        </template>
    <script>
    export default {
    data() {
    return {
      form: {},
    }
    },
    }
    </script>
`,

  // 树形查询
  SelectTreeCode: `<template>
    <div>
      <select-tree v-model="form.minecode"
      :options="minelist"
      :props="{
        value: 'id', 
        label: 'deptName',
        children: 'children',
      }" />
      <el-button type="primary" @click="submit">submit!</el-button>
    </div>
  </template>
  <script>
  export default  {
  data() {
  return {
    // 绑定对象
    form: {
      minecode: "1-1"
    },
    // 数据源
    minelist: [
        {
        "id":"1",// 对应 value
        "deptName":"布雷德科技",//对应label
        "parentId":"0",
        "parentName":"顶级",
          "children":[ //对应children
              {
              "id":"1-1",
              "parentId":"1",
              "deptName":"常州布雷德",
              "parentName":"布雷德科技",
              },
              {
              "id":"1-2",
              "parentId":"1",
              "deptName":"苏州布雷德",
              "parentName":"布雷德科技",
              }
          ],
        }
    ]
  };
  },
    methods:{
      submit(){
      console.log(this.form,'submit！！！');
      }
    }
  };
  </script>
  
  `,
  AvueSelectTree: `
  <template>
            <avue-form :option="option"></avue-form>
  </template>
 <script>
    export default {
      data() {
        return {
          option: {
            labelWidth: 150,
            submitBtn: false, //关闭提交按钮
            emptyBtn: false, //关闭清空按钮
            column: [
              {
                label: '单位多选配置效果',
                prop: 'tree',
                type: 'tree',
                multiple: true,
                span: 8,
                dicUrl: "/api/blade-system/dept/treeByUser",
                props: {
                  label: "deptName",
                  value: "id"
                },
              },
            ]
          }
        }
      },
    }
</script>
`,
  // 对话框
  DialogResetCode1: `
  <template>
    <div>
      <el-button type="text"
                @click="dialogVisible1 = true">打开DialogReset</el-button>
      <dialog-reset :visible.sync="dialogVisible1"
                    top='10vh'
                    height="50vh"
                    width="60%"
                    zoomShow
                    :modalShow="false"
                    ask_Dialogdrag
                    title="DialogReset示例2">
        <div v-for="index in 30"
            :key="index"
            style="height:100px">自定义内容区域{{index}}</div>
        <span slot="dialog_footer"
              class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary"
                    @click="dialogVisible1 = false">确 定</el-button>
        </span>
      </dialog-reset>

    </div>
  </template>

  <script>

  export default {
    data() {
      return {
        dialogVisible1: false,
      };
    }
  };
  </script>

  <style scoped lang='scss'>
  </style>
  `,
  DialogResetCode2: `
  <template>
    <div>
      <!-- 组件嵌套  推荐用法-->
      <el-button type="text"
                @click="dialogVisible3 = true">打开DialogReset</el-button>
        <dialog-reset :visible.sync="dialogVisible3"
                      top='10vh'
                      height="50vh"
                      ask_Dialogdrag
                      title="DialogReset示例3">

      // =============================== dialog-reset-demo-children 为实际的业务组件 想了解内部写法可搜索 DialogResetDemoChildren.vue 查看   =============================

          <dialog-reset-demo-children @callSwitch="dialogVisible3=false"
                                      ref="DialogResetDemoChildren"></dialog-reset-demo-children>
        </dialog-reset>
    </div>
</template>

<script>

import DialogResetDemoChildren from './DialogResetDemoChildren.vue'  //内部嵌入组件
export default {
  components: {
    DialogResetDemoChildren
  },
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
    };
  },
 
};
</script>
`,
  DialogResetCode3: `
<template>
    <div>
      <!-- 对话框组件嵌套2-->
      <el-button type="text"
                @click="dialogVisible4 = true">打开DialogReset &nbsp;&nbsp;</el-button>
      <dialog-reset :visible.sync="dialogVisible4"
                    top='10vh'
                    height="50vh"
                    title="DialogReset示例4">
  =============================== dialog-reset-demo-children 为实际的业务组件 想了解内部写法可搜索 DialogResetDemoChildren.vue 查看   =============================
            <dialog-reset-demo-children @callSwitch="dialogVisible4=false"
                                        ref="DialogResetDemoChildren2"
                                        :showBtn='false'></dialog-reset-demo-children>
            <span slot="dialog_footer">
              <el-button @click="callSwitch()">取 消(具名插槽传入)</el-button>
              <el-button type="primary"
                        @click="submitForm()">确 定(具名插槽传入)</el-button>
            </span>
      </dialog-reset>
    </div>
</template>

<script>

import DialogResetDemoChildren from './DialogResetDemoChildren.vue'  //内部嵌入组件
export default {
components: {
  DialogResetDemoChildren
},
data() {
  return {
    dialogVisible1: false,
    dialogVisible2: false,
    dialogVisible3: false,
    dialogVisible4: false,
  };
},

};
</script>
`,
  // 整数，小数输入框
  CustomInputCode: `<template>
  <el-form ref="form"
           :model="formData"
           label-width="150px">
    <el-row>
      <el-col :span="7">
        <el-form-item label="整数，小数输入示例:">
          <custom-input v-model="formData.title"
                        maxlength="6" // 长度6位
                        precision="2" // 保留两位小数
                        placeholder="请输入"></custom-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      formData: { title: '' }
    }
  },
  created() {
  },
}
</script>
  `,
  // 按钮
  ButtonClip: `
            <el-button type="primary" size="small" icon="el-icon-plus">新增</el-button>
            <el-button size="small" plain icon="el-icon-edit">修改</el-button>
            <el-button size="small" plain icon="el-icon-view">查看</el-button>
            <el-button size="small" plain icon="el-icon-upload2">导入</el-button>
            <el-button size="small" plain icon="el-icon-circle-check">审核</el-button>
            <el-button size="small" plain icon="el-icon-download">导出</el-button>
            <el-button size="small" plain icon="el-icon-check">启用</el-button>
            <el-button size="small" plain icon="el-icon-circle-plus-outline">追加</el-button>
            <el-button size="small" plain icon="el-icon-remove-outline">扣减</el-button>
            <el-button size="small" plain icon="el-icon-document-checked">解冻</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete">删除</el-button>
            <el-button size="small" type="danger" icon="el-icon-document-delete">作废</el-button>
            <el-button size="small" icon="el-icon-document-delete">冻结</el-button>
            <el-button size="small" icon="el-icon-refresh-left">驳回</el-button>
            <el-button size="small" icon="el-icon-check">禁用</el-button>
            <el-button size="small" icon="el-icon-circle-close">取消审核</el-button>

  `,
  // 日期类配置效果
  DateCode1: `
  /* 
   * 1.仅展示结构 非此演示相关配置省略, 具体配置参考此页面 Avue 常用 option 参数说明中 searchDateProp 参数
   * 2.生成代码实现对应效果 复制对应配置即可， 自定义的可参照具体实例源码
   * 3.字段为 searchDate的时间集配置 默认处理searchDateProp配置 默认一周
   */
    <template>
        <avue-crud    
          .........................>

        </avue-crud>
    </template>
    <script>
        export default {
          data() {
            return {

      ---------------- 单个时间 option 配置  -------------------------
      option: {
        .........................,
        searchDateProp: { startTime: 'searchDateToday', type: 'today' },
        column: [
                          .........................,
                          {
                            label: "单个时间",
                            prop: "searchDateToday",
                            type: "date",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd",
                          },
                  ]
              }
      -------------------  end  ----------------------------

      ---------------- 时间集 option 配置 -------------------------
      option: {
        ...............,
        column: [
                          .........................,
                          {
                            label: "时间集",
                            prop: "searchDate",
                            type: "datetime",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            searchRange: true,
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                          },
                  ]
                }
      --------------------------------------  end  --------------------------------------------

    
            }
          },
        }
    </script>
    `,

  DateCode2: `
    /* 
     * 1.仅展示结构 非此演示相关配置省略, 具体配置参考此页面 Avue 常用 option 参数说明中 searchDateProp 参数
     * 2.生成代码实现对应效果 复制对应配置即可， 自定义的可参照具体实例源码
     * 3.字段为 searchDate的时间集配置 默认处理searchDateProp配置 默认一周
     */
      <template>
          <avue-crud    
            .........................>
  
          </avue-crud>
      </template>
      <script>
          export default {
            data() {
              return {
  
                ---------------------- 时间集(默认一天) option 配置  -------------------------
      option: {
        .........................,
        searchDateProp: { startTime: 'searchDateDay', type: 'day' },
        column: [
                          .........................,
                          {
                            label: "时间集(默认一天)",
                            prop: "searchDateDay",
                            type: "datetime",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            searchRange: true,
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                          },
                  ]
              }
      ----------------------------  end  -----------------------------------------------

      --------------------- 时间集(默认一个月) option 配置  ------------------------------
      option: {
        .........................,
        searchDateProp: { startTime: 'searchDateMonth', type: 'month' },
        column: [
                          .........................,
                          {
                            label: "时间集(默认一个月)",
                            prop: "searchDateMonth",
                            type: "datetime",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            searchRange: true,
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                          },
                  ]
              }
  
              }
            },
          }
      </script>
      `,

  DateCode3: `
  /* 
   * 1.仅展示结构 非此演示相关配置省略, 具体配置参考此页面 Avue 常用 option 参数说明中 searchDateProp 参数
   * 2.生成代码实现对应效果 复制对应配置即可， 自定义的可参照具体实例源码
   * 3.字段为 searchDate的时间集配置 默认处理searchDateProp配置 默认一周
   */
    <template>
        <avue-crud    
          .........................>

        </avue-crud>
    </template>
    <script>
        export default {
          data() {
            return {

              ------------------------------- 时间组默认值 option 配置 ------------------------------- 
              option: {
                .............................,
                searchDateProp:{ startTime:'searchDateStart2', endTime:'searchDateEnd2', },
                column: [
                                  .........................,
                                  {
                                    label: "时间组默认值(开始)",
                                    prop: "searchDateStart2",
                                    type: "datetime",
                                    dataType: 'string',
                                    hide: true,
                                    showColumn: false,
                                    search: true,
                                    addDisplay: false,
                                    editDisplay: false,
                                    viewDisplay: false,
                                    dateDefault: true,
                                    overHidden: true,
                                    format: "yyyy-MM-dd HH:mm:ss",
                                    valueFormat: "yyyy-MM-dd HH:mm:ss",
                                  },
                                  {
                                    label: "时间组默认值(结束)",
                                    prop: "searchDateEnd2",
                                    type: "datetime",
                                    dataType: 'string',
                                    hide: true,
                                    showColumn: false,
                                    search: true,
                                    addDisplay: false,
                                    editDisplay: false,
                                    viewDisplay: false,
                                    dateDefault: true,
                                    overHidden: true,
                                    format: "yyyy-MM-dd HH:mm:ss",
                                    valueFormat: "yyyy-MM-dd HH:mm:ss",
                                  },
                          ]
                        }
       ------------------------------------  end  ----------------------------------------------


      ---------------- 时间组 option 配置 (无默认值 通用文件不会做任何处理)-------------------------
      option: {
        .............................,
        column: [
                          .........................,
                          {
                            label: "时间组(开始)",
                            prop: "searchDateStart",
                            type: "datetime",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                          },
                          {
                            label: "时间组(结束)",
                            prop: "searchDateEnd",
                            type: "datetime",
                            dataType: 'string',
                            hide: true,
                            showColumn: false,
                            search: true,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: false,
                            dateDefault: true,
                            overHidden: true,
                            format: "yyyy-MM-dd HH:mm:ss",
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                          },
                  ]
                }
      ---------------------------------  end  ------------------------------------



            }
          },
        }
    </script>
    `,

  DateCode4: `
    /* 
     * 1.仅展示结构 非此演示相关配置省略, 具体配置参考此页面 Avue 常用 option 参数说明中 searchDateProp 参数
     * 2.生成代码实现对应效果 复制对应配置即可， 自定义的可参照具体实例源码
     * 3.字段为 searchDate的时间集配置 默认处理searchDateProp配置 默认一周
     */
      <template>
          <avue-crud    
            .........................>
  
          </avue-crud>
      </template>
      <script>
          export default {
            data() {
              return {
  
  
        ---------------- 日期组(默认值30天) option 配置 -------------------------
        option: {
          .............................,
          searchDateProp:{ startTime:'thirtyDaysStart', endTime:'thirtyDaysEnd', type: 'monthRecent' },
          column: [
                            .........................,
  
                            {
                              label: "日期组默认30天(开始)",
                              prop: "thirtyDaysStart",
                              type: "date",
                              dataType: 'string',
                              hide: true,
                              showColumn: false,
                              search: true,
                              addDisplay: false,
                              editDisplay: false,
                              viewDisplay: false,
                              dateDefault: true,
                              overHidden: true,
                              format: "yyyy-MM-dd",
                              valueFormat: "yyyy-MM-dd",
                            },
                            {
                              label: "日期组默认30天(结束)",
                              prop: "thirtyDaysEnd",
                              type: "date",
                              dataType: 'string',
                              hide: true,
                              showColumn: false,
                              search: true,
                              addDisplay: false,
                              editDisplay: false,
                              viewDisplay: false,
                              dateDefault: true,
                              overHidden: true,
                              format: "yyyy-MM-dd",
                              valueFormat: "yyyy-MM-dd",
                            },
                    ]
                  }
        -----------------------------  end  ---------------------------------

              }
            },
          }
      </script>
      `,
}
// -----------------------------  end   -----------------------------------------------------------------


// ----------------------------   通用维护方法   ------------------------------------------------------------
import { highlight, languages } from "prismjs/components/prism-core";
import { PrismEditor } from "vue-prism-editor";
export const DescMethod = {
  initialize: () => {
    require("prismjs/components/prism-clike")
    require("prismjs/components/prism-javascript")
    require("prismjs/themes/prism-tomorrow.css")
    require("vue-prism-editor/dist/prismeditor.min.css")
  },
  htmlValue: (val) => {
    if (val) {
      let param = '@param'
      let period = '。'
      let children = '--'
      let stress = '##'
      let paramHlmt = val.replace(
        new RegExp(param, 'g'),
        `<span style='${'color:#569CD6;font-size:16px;font-weight:800;'}'>${param}</span>`
      );
      let periodHlmt = paramHlmt.replace(
        new RegExp(period, 'g'),
        `<span  >${period}<br/></span>`
      );
      let bracketHlmt = periodHlmt.replace(
        new RegExp('{', 'g'),
        `<span  style='${'color:#CE4A5D;font-weight: 900;'}' >${' { '} </span>`
      );
      let bracketHlmt2 = bracketHlmt.replace(
        new RegExp('}', 'g'),
        `<span  style='${'color:#CE4A5D;font-weight: 900;'}' >${' } '}</span>`
      );
      let childrenHlmt = bracketHlmt2.replace(
        new RegExp(children, 'g'),
        '<span  style=color:#67C23A;font-weight:900;>&nbsp;&nbsp;' + children + '</span>'
      );
      let stressHlmt = childrenHlmt.replace(
        new RegExp(stress, 'g'),
        `<span  style='${'color: rgb(90, 47, 47);font-weight: 800;font-size:17px;'}' >${stress}</span>`
      );
      return stressHlmt
    }
    return val;
  },
  highlight,
  languages,
  PrismEditor
}
 // -----------------------------  end   -----------------------------------------------------------------
